import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';

const BulkRegenerateDocumentsModal = ({ isOpen, onClose, onConfirm, documents, loading, getAssigneeName }) => {
  if (!isOpen || !documents || documents.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Regenerate Documents</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to regenerate {documents.length} document{documents.length > 1 ? 's' : ''}?</p>
          <div className="bulk-document-list">
            {documents.slice(0, 5).map(document => (
              <div key={document.documentId} className="bulk-document-item">
                <div className="bulk-document-name">{document.documentTitle || "Untitled"}</div>
                <div className="bulk-document-assignee">{getAssigneeName(document.assigneeId)}</div>
              </div>
            ))}
            {documents.length > 5 && (
              <div className="bulk-document-more">
                ... and {documents.length - 5} more document{documents.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            This will create new AI-generated content for all selected documents, replacing their current content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="regenerate-confirm-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              `Regenerate All`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkRegenerateDocumentsModal;
